import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { ConfigurationWell } from "components/configurationforms";
import InputStaticFields from "components/inputs/InputStaticFields";
import SectionGrid from "components/common/Section/SectionGrid";
import { ThroughputSection } from "components/inputs/InputsOveriew";
import { InputForm } from "components/inputs";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useInputMutations from "hooks/useInputMutations";
const StyledSpan = styled.span`
  display: flex;
  justify-content: flex-end;
`;
const ExpandedConfigurationSection = ({ input, inputTypeDescriptions }) => {
  const definition = inputTypeDescriptions[input.type];
  const [showConfigurationForm, setShowConfigurationForm] = useState(false);
  const sendTelemetry = useSendTelemetry();
  const { updateInput } = useInputMutations();
  const editInput = () => {
    setShowConfigurationForm(true);
  };
  const hanleInputUpdate = async (inputData) => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.INPUTS.INPUT_UPDATED, {
      app_action_value: "input-edit"
    });
    await updateInput({ input: inputData, inputId: input.id });
  };
  return /* @__PURE__ */ React.createElement(SectionGrid, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(SectionGrid, null, /* @__PURE__ */ React.createElement("span", null, " ", input.name, " \xA0 (", input.id, ")"), /* @__PURE__ */ React.createElement(StyledSpan, null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", bsSize: "xsmall", onClick: editInput, disabled: definition === void 0 }, "Edit input"))), /* @__PURE__ */ React.createElement(ConfigurationWell, { id: input.id, configuration: input.attributes, typeDefinition: definition })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", null, "Throughput / Metrics"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(ThroughputSection, { input }), /* @__PURE__ */ React.createElement(InputStaticFields, { input })), definition && showConfigurationForm && /* @__PURE__ */ React.createElement(
    InputForm,
    {
      setShowModal: setShowConfigurationForm,
      key: `edit-form-input-${input.id}`,
      globalValue: input.global,
      nodeValue: input.node,
      configFields: definition.requested_configuration,
      description: definition == null ? void 0 : definition.description,
      title: `Editing Input ${input.title}`,
      titleValue: input.title,
      typeName: input.type,
      includeTitleField: true,
      handleSubmit: hanleInputUpdate,
      submitButtonText: "Update input",
      values: input.attributes
    }
  ));
};
export default ExpandedConfigurationSection;
